document.querySelector('input[name="serialNumber"]').addEventListener('keydown', event => {
    if (event.key === 'Enter') {
        event.preventDefault();
        document.querySelector('button[name="openCase"]').click();
    }
});
